export default __webpack_public_path__ + "static/media/icon3dcode1.03ae670a.png";